export default "__VITE_ASSET__B1NF1NwL__"